import { useMemo } from 'react';
import useEntities from 'new/state/entities/repository/useEntities';

export default function useReusableTransforms(type = 'query_rewriter') {
  const { data: transforms } = useEntities('transforms');
  return useMemo(() => {
    const reusableTransforms = Object.values<any>(transforms).filter(
      (transform) =>
        transform.reusable &&
        transform.resource_type === 'ai_function' &&
        transform.ai_function_type === type,
    );
    return {
      transforms,
      reusableTransforms,
    };
  }, [transforms]);
}
